import { createStore } from 'vuex'
export default createStore({
  state: {
    currentImg: {},
    markedList: [],
    dxfList: [
    ],
    dxfListIndex: 0, // 当前操作的dxfList对应的下标
    currentPxf: {}, // 当前操作的dxfList对应的项
    currentMarkList: [],
    status: '',
    socket: null
  },
  getters: {
  },
  mutations: {
    setCurrentImg (state, obj) {
      state.currentImg = obj
    },
    pushMarkList (state, obj) {
      state.markedList.push(obj)
    },
    setDxfList (state, obj) {
      console.log(obj, 'obj>>>>>>>>888888')
      state.dxfList = obj
      console.log(state.dxfList, 'state.dxfList>>')
    },
    setCurrentPxf (state, obj) {
      console.log(obj, 'obj>>>>>>>>')
      state.currentPxf = obj
    },
    setDxfListIndex (state, num) {
      state.dxfListIndex = num
    },
    setCurrentMarkList (state, list) {
      state.currentMarkList = list
    },
    setSocketStatus (state, str) {
      state.status = str
    },
    setSocket (state, obj) {
      state.socket = obj
    }

  },
  actions: {
  },
  modules: {
  }
})
